import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import LicenseList from "../components/license/LicenseList";

const LicenseListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Licenses" />

        {/* LicenseList */}
        <LicenseList />
      </MasterLayout>
    </>
  );
};

export default LicenseListPage;
